import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import M from 'materialize-css';
import { Container, Col, Modal, RadioGroup, TextInput, Collection, CollectionItem } from 'react-materialize';
import styled from 'styled-components';
import { SIZE, LABEL, COLOR, FONT_FAMILY, URL, SCREEN_MEDIA } from '../../utils/constants.js';
import { useDecorationTypes } from '../hooks/useDecorationTypes.js';
import { useDecorationPortraits } from '../hooks/useDecorationPortraits.js';
import {
    getDecorationTypeLv1List,
    getDecorationPortraitByTypeLv1
} from '../../utils/managerdecorations.js';
import {
    getDecorationTypesFromSearchPhrase,
    getBirthOptionList
} from '../../utils/managersearch.js';
import Row from '../organism/row.jsx';
import Path from '../molecules/path.jsx';
import Button from '../atoms/button.jsx';
import TextIcon from '../atoms/texticon.jsx';
import Divider from '../atoms/divider';
import FixedButtons from '../molecules/fixedbuttons.jsx';
import Photos from '../organism/photos.jsx';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Label } from '../atoms/label.jsx';
import LoadingSpinner from '../organism/spinner.jsx';



import PathWapp from '../../icons/ic_wapp.svg';
import PathFb from '../../icons/ic_fb_colored.svg';
import PathTikTok from '../../icons/ic_tiktok.svg';
import PathInsta from '../../icons/ic_instagram_colored.svg';

import PathIcSarch from '../../icons/ic_search.svg'


import PathPhotoBirth01 from '../../images_categories/birth50g/img_008_001.webp';
import PathPhotoBirth02 from '../../images_categories/birth/img_036_004.webp';
import PathPhotoBirth03 from '../../images_categories/birth0214/img_034_001.webp';

import PathPhotoBabyshower01 from '../../images_categories/babyshower/img_001_001.webp';
import PathPhotoBabyshower02 from '../../images_categories/babyshower/img_005_002.webp';
import PathPhotoBabyshower03 from '../../images_categories/babyshower/img_004_002.webp';

import PathPhotoCelebration01 from '../../images_categories/celebrations/img_001_vertical.webp';
import PathPhotoCelebration02 from '../../images_categories/celebrations/img_017_003_thumbnail.webp';
import PathPhotoCelebration03 from '../../images_categories/celebrations/img_028_005_thumbnail.webp';

import PathPhotoRomantic01 from '../../images_categories/romantic/img_001_002_thumbnail.webp';
import PathPhotoRomantic02 from '../../images_categories/romantic/img_002_005_thumbnail.webp';
import PathPhotoRomantic03 from '../../images_categories/romantic/img_004_004_thumbnail.webp';

import PathPhotoReligion01 from '../../images_categories/religion/img_001.webp';
import PathPhotoReligion02 from '../../images_categories/religion/img_002.webp';
import PathPhotoReligion03 from '../../images_categories/religion/img_003_000.webp';

import PathPhotoWedding01 from '../../images_categories/wedding/img_003_004_thumbnail.webp';
import PathPhotoWedding02 from '../../images_categories/wedding/img_002_02_vertical.webp';
import PathPhotoWedding03 from '../../images_categories/wedding/img_003_002_thumbnail.webp';

import PathPhotoWelcome01 from '../../images_categories/welcome/img_001_003.webp';
import PathPhotoWelcome02 from '../../images_categories/welcome/img_001_002.webp';
import PathPhotoWelcome03 from '../../images_categories/welcome/img_001_001.webp';


const RowClickable = styled(Row)`
    &:hover {
        cursor: pointer;
    }
`

const RadioContent = styled.div`
    [type="radio"] {
        &:checked+span {
            &::before {
                border: 2px solid ${COLOR.ferra};
            }
            &:after {
                background-color: ${COLOR.ferra};
                border: 1px solid ${COLOR.ferra};
            }
        }
    }
    label {
        color: ${COLOR.ferra};
        font-size: 36px;
        width: 100%;
        display: inline-block;
    }
`


const TextInputLayer = styled.div`
    height: 45px;
    width: 100%;
    border: 2px solid ${COLOR.ferra};
    border-radius: 4px;
    cursor: text;
`;


const SearchSuggestionBackground = styled.div`
    height: 100%; // It is not working, this is set dynamically
    width: 100%;
    position: absolute;
    background-color: ${COLOR.background};
    display: none;
    @media only screen and ${SCREEN_MEDIA.small} {
        top: 56px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        top: 64px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        top: 64px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        top: 64px;
    }
    z-index: 1;
`;

const SearcherSuggestionDiv = styled.div`
    height: 400px;
    background-color: ${COLOR.white};
    overflow: auto;
    position: absolute;
    @media only screen and ${SCREEN_MEDIA.small} {
        width:90%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        width:85%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        width:70%;
        top: 90px;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        width:70%;
        top: 90px;
    }
`


const ThematicsGrid = styled.div`
    display: grid;
    @media only screen and ${SCREEN_MEDIA.small} {
        grid-template-columns: 1fr;
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        grid-template-columns: 1fr 1fr;
    }
    @media only screen and ${SCREEN_MEDIA.long} {
        grid-template-columns: 1fr 1fr;
    }
    @media only screen and ${SCREEN_MEDIA.xlong} {
        grid-template-columns: 1fr 1fr;
    }
`;

const ThematicItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
`;

const BodyThematic = () => {

    const { data: decorationTypeList, isLoading: isTypesLoading } = useDecorationTypes();
    const { data: decorationPortraitList, isLoading: isPortraitsLoading } = useDecorationPortraits();

    const isLoading = isTypesLoading || isPortraitsLoading || !decorationTypeList || !decorationPortraitList;

    const decorationTypesLv1 = useMemo(() => {
        return decorationTypeList ? getDecorationTypeLv1List(decorationTypeList) : [];
    }, [decorationTypeList]);

    const birthOptions = useMemo(() => {
        return decorationTypeList ? getBirthOptionList(decorationTypeList) : [];
    }, [decorationTypeList]);


    const [subcategoryBirthModal, setSubcategoryBirthModal] = useState();
    const [searchSuggestionList, setSearchSuggestionList] = useState([])
    const [birthOptionSelectedId, setBirthOptionSelectedId] = useState(null);
    
    const navigate = useNavigate();

    const searchInputTextRef = useRef()


    useEffect(() => {
        if (birthOptions.length > 0 && !birthOptionSelectedId) {
            setBirthOptionSelectedId(birthOptions[0].value);
        }
    }, [birthOptions, birthOptionSelectedId]);

    useEffect(() => {
        if (decorationTypesLv1 &&
            decorationTypesLv1.length > 0
        ) {
            setSearchSuggestionList(decorationTypesLv1)
        }
    }, [decorationTypesLv1]);

    useEffect(() => {
        if (!isLoading) {
            window.scrollTo(0, 0);
            
            var birthModal = M.Modal.getInstance($('#modalBirthSubcategoriesId')); // Init modal
            setSubcategoryBirthModal(birthModal);
        }
      }, [isLoading]);

    const onSubcategoryBirthApplied = () => {
        subcategoryBirthModal.close()
        const path = URL.decorations.replace(':searchId', birthOptionSelectedId);
        navigate(path)
    }

    const navigateToDecorations = (searchId) => {
        console.log(`Thematic searchId: ${searchId}`)
        const path = URL.decorations.replace(':searchId', searchId);
        navigate(path)
    }

    const handleSearchOnkeyDown = (event) => {
        if (event.key === 'Enter') {
        }
    }

    const handleOnSearchDismissed = () => {
        $(searchInputTextRef.current).blur()
        $('#search_suggestion_background').css('display', 'none')
    }

    const onSearchInputLayerClicked = () => {
        $('#search_suggestion_background').css('height', $('#root').height());
        $('#search_suggestion_background').css('display', 'block')
        $(searchInputTextRef.current).focus()
    }

    const onSearchInputTextChanges = (event) => {
        const searchPhrase = event.target.value.trim()
        const suggestionList = getDecorationTypesFromSearchPhrase(decorationTypeList, searchPhrase)
        setSearchSuggestionList(suggestionList)
    }

    const onThematicItemClicked = (typeLv1Id) => {
        if (typeLv1Id === 100001) {
            subcategoryBirthModal.open()
        } else {
            navigateToDecorations(typeLv1Id)
        }
    }

    if (isLoading) return <LoadingSpinner/>;

    return(
        <div>
  
            <Container>
                <FixedButtons
                    items={[
                        { href: URL.whatsapp, ic_path: PathWapp, ic_size: '50px' },
                        { href: URL.facebook, ic_path: PathFb, ic_size: '50px' },
                        { href: URL.tiktok, ic_path: PathTikTok, ic_size: '50px' },
                        { href: URL.instagram, ic_path: PathInsta, ic_size: '50px' }
                        ]}
                    aligment='right'/>

                <Row className='valign-wrapper' margin='40px 0'>
                    <TextInputLayer
                        onClick={ () => { onSearchInputLayerClicked() } }>
                        <Label
                        text_color={COLOR.gray}
                        text_size='20px'
                        font_family={FONT_FAMILY.avenirBook}
                        margin='7px 14px'>
                        Buscar temática
                        </Label>
                    </TextInputLayer>
                </Row>
                

                <Row
                    margin='0 0'>
                    <Path 
                        endpoint={LABEL.thematics} />
                </Row>

                <ThematicsGrid>
                {
                    decorationTypesLv1?.map((item, index) => {
                        const portraitsByType = getDecorationPortraitByTypeLv1(decorationPortraitList, item.id)
                        return <ThematicItem key={item.id} onClick={() => { onThematicItemClicked(item.id) }}>
                            <Photos
                            photo_01_src={ portraitsByType[0].src }
                            photo_01_rotation='10deg'
                            photo_02_src={ portraitsByType[1].src }
                            photo_02_rotation='-2deg'
                            photo_03_src={ portraitsByType[2].src }
                            photo_03_rotation='-10deg'
                            margin='60px 0 10px 0'/>
                            <Label
                            text_size={SIZE.display}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.avenirLight}>
                            { item.title }
                            </Label>
                        </ThematicItem>
                    })
                }
                </ThematicsGrid>

                {/* <RowClickable className='valign-wrapper' onClick={ () => { subcategoryBirthModal.open() } }>
                    <Col s={12} m={12} l={2} xl={2}>
                        <Label
                            text_size={SIZE.display_top}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.unicorns}>
                            { decorationTypeList[0].title }
                        </Label>
                    </Col>
                    <Col s={5} m={6} l={4} xl={4}>
                        <Photos
                            photo_01_src={ PathPhotoBirth01 }
                            photo_01_rotation='-5deg'
                            photo_02_src={ PathPhotoBirth02 }
                            photo_02_rotation='2deg'
                            photo_03_src={ PathPhotoBirth03 }
                            photo_03_rotation='10deg'
                            margin='30px 0'/>
                    </Col>
                    <Col s={7} m={4} l={3} xl={2}></Col>
                </RowClickable> */}

                <Modal
                    id="modalBirthSubcategoriesId"
                    header="Selecciona una subcategoría"
                    fixedFooter={ true } //If true breaks DatePickers
                    actions={[
                    <Button 
                        onClick={() => { onSubcategoryBirthApplied() }}
                        width='120px'
                        height='46px'
                        bg_color={COLOR.primary}
                        float='right'>
                        <Label
                            text_color={ COLOR.ferra }
                            text_size={SIZE.headline}
                            font_family={FONT_FAMILY.unicorns}
                            margin='auto'>
                            Aplicar
                        </Label>
                    </Button>
                    ]}>
                    <Row margin='30px 0 0 0'>
                        <RadioContent>
                        <RadioGroup
                            label="Birth-filter"
                            name="size"
                            className='valign-wrapper'
                            withGap={ true }
                            options={ birthOptions }
                            value={ birthOptionSelectedId }
                            onChange={(event) => setBirthOptionSelectedId(event.target.value)}
                            />
                        </RadioContent>
                    </Row>
                </Modal>

                {/* <Divider/>


                <RowClickable className='valign-wrapper' onClick={ () => navigateToDecorations(decorationTypeList[3].id) }>
                    <Col s={12} m={12} l={2} xl={2}>
                        <Label
                            text_size={SIZE.display_top}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.unicorns}
                            margin='40px 0 0 0'> 
                            { decorationTypeList[3].title }
                        </Label>
                    </Col>
                    <Col s={5} m={6} l={4} xl={4}>
                        <Photos
                            photo_01_src={ PathPhotoRomantic01 }
                            photo_01_rotation='-12deg'
                            photo_02_src={ PathPhotoRomantic02 }
                            photo_02_rotation='-10deg'
                            photo_03_src={ PathPhotoRomantic03 }
                            photo_03_rotation='8deg'
                            margin='50px 0'/>
                    </Col>
                    <Col s={7} m={4} l={3} xl={2}></Col>
                </RowClickable>

                <Divider/>

                <RowClickable className='valign-wrapper' onClick={ () => navigateToDecorations(decorationTypeList[4].id) }>
                    <Col s={12} m={12} l={2} xl={2}>
                        <Label
                            text_size={SIZE.display_top}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.unicorns}
                            margin='40px 0 0 0'> 
                            { decorationTypeList[4].title }
                        </Label>
                    </Col>
                    <Col s={5} m={6} l={4} xl={4}>
                        <Photos
                            photo_01_src={PathPhotoWedding01}
                            photo_01_rotation='-6deg'
                            photo_02_src={PathPhotoWedding02}
                            photo_02_rotation='1deg'
                            photo_03_src={ PathPhotoWedding03 }
                            photo_03_rotation='8deg'
                            margin='50px 0'/>
                    </Col>
                    <Col s={7} m={4} l={3} xl={2}></Col>
                </RowClickable>

                <Divider/>

                <RowClickable className='valign-wrapper' onClick={ () => navigateToDecorations(decorationTypeList[1].id) }>
                    <Col s={12} m={12} l={2} xl={2}>
                        <Label
                            text_size={SIZE.display_top}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.unicorns}
                            margin='40px 0 0 0'> 
                            { decorationTypeList[1].title }
                        </Label>
                    </Col>
                    <Col s={5} m={6} l={4} xl={4}>
                        <Photos
                            photo_01_src={ PathPhotoBabyshower01 }
                            photo_01_rotation='-10deg'
                            photo_02_src={ PathPhotoBabyshower02 }
                            photo_02_rotation='-3deg'
                            photo_03_src={ PathPhotoBabyshower03 }
                            photo_03_rotation='8deg'
                            margin='50px 0'/>
                    </Col>
                    <Col s={7} m={4} l={3} xl={2}></Col>
                </RowClickable>

                <Divider/>


                <RowClickable className='valign-wrapper' onClick={ () => navigateToDecorations(decorationTypeList[6].id) }>
                    <Col s={12} m={12} l={2} xl={2}>
                        <Label
                            text_size={SIZE.display_top}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.unicorns}
                            margin='40px 0 0 0'> 
                            { decorationTypeList[6].title }
                        </Label>
                    </Col>
                    <Col s={5} m={6} l={4} xl={4}>
                        <Photos
                            photo_01_src={PathPhotoWelcome01}
                            photo_01_rotation='6deg'
                            photo_02_src={PathPhotoWelcome02}
                            photo_02_rotation='1deg'
                            photo_03_src={ PathPhotoWelcome03 }
                            photo_03_rotation='-8deg'
                            margin='50px 0'/>
                    </Col>
                    <Col s={7} m={4} l={3} xl={2}></Col>
                </RowClickable>

                <Divider/>


                <RowClickable className='valign-wrapper' onClick={ () => navigateToDecorations(decorationTypeList[2].id) }>
                    <Col s={12} m={12} l={2} xl={2}>
                        <Label
                            text_size={SIZE.display_top}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.unicorns}> 
                            { decorationTypeList[2].title }
                        </Label>
                    </Col>
                    <Col s={5} m={6} l={4} xl={4}>
                        <Photos
                            photo_01_src={PathPhotoCelebration01}
                            photo_01_rotation='-10deg'
                            photo_02_src={PathPhotoCelebration02}
                            photo_02_rotation='-2deg'
                            photo_03_src={PathPhotoCelebration03}
                            photo_03_rotation='4deg'
                            margin='30px 0'/>
                    </Col>
                    <Col s={7} m={4} l={3} xl={2}></Col>
                </RowClickable>

                <Divider/>
                

                <RowClickable className='valign-wrapper' onClick={ () => navigateToDecorations(decorationTypeList[5].id) }>
                    <Col s={12} m={12} l={2} xl={2}>
                        <Label
                            text_size={SIZE.display_top}
                            text_color={COLOR.secondary}
                            text_align='center'
                            font_family={FONT_FAMILY.unicorns}
                            margin='40px 0 0 0'> 
                            { decorationTypeList[5].title }
                        </Label>
                    </Col>
                    <Col s={5} m={6} l={4} xl={4}>
                        <Photos
                            photo_01_src={ PathPhotoReligion02 }
                            photo_01_rotation='-5deg'
                            photo_02_src={ PathPhotoReligion03 }
                            photo_02_rotation='4deg'
                            photo_03_src={ PathPhotoReligion01 }
                            photo_03_rotation='4deg'
                            margin='50px 0'/>
                    </Col>
                    <Col s={7} m={4} l={3} xl={2}></Col>
                </RowClickable> */}
  
            </Container>

            <SearchSuggestionBackground
                id='search_suggestion_background'
                onClick={ () => { handleOnSearchDismissed() } }>
                <Container>
                <Row margin='40px 0'>
                    <Col s={8} m={8} l={10} xl={11}>
                        <TextInput
                        ref={searchInputTextRef}
                        placeholder='Buscar temática'
                        onChange={ (event) => { onSearchInputTextChanges(event) } }
                        onKeyDown={ (event) => { handleSearchOnkeyDown(event) } }/>
                    </Col>
                    <Col s={4} m={4} l={2} xl={1}>
                    <Button
                        onClick={ () => { handleOnSearchDismissed() } }
                        height='40px'>
                        <Label
                        font_family={FONT_FAMILY.avenirLight}
                        text_color={COLOR.ferra}>
                            { LABEL.cancel }
                        </Label>
                    </Button>
                    
                    </Col>
                </Row>
                <Row>
                    <SearcherSuggestionDiv>
                    <Collection>
                    {
                        searchSuggestionList.map((searchSuggestion, index) =>
                            <CollectionItem
                                key={index}
                                onClick={ () => { navigateToDecorations(searchSuggestion.id) } }
                                style={{ cursor: 'pointer' }}>
                                <TextIcon
                                    ic_path={PathIcSarch}
                                    ic_size='18px'
                                    ic_color={COLOR.ferra}>
                                </TextIcon>
                                <Label
                                    text_size={SIZE.subtitle}
                                    text_color={COLOR.ferra}
                                    font_family={FONT_FAMILY.avenirMedium}> 
                                    {searchSuggestion.title}
                                </Label>
                                
                            </CollectionItem>
                        )
                    }
                    </Collection>
                    </SearcherSuggestionDiv>
                </Row>
                </Container>
            </SearchSuggestionBackground>

        </div>
    );
}

export default BodyThematic;